import React from "react";
import NavBar from '../components/navbar';
import Footer from '../components/Footer';
import Profile from '../assets/TalentDashboard/1-Profile.png';
import Skills from '../assets/TalentDashboard/2-Skills.png';
import Community from '../assets/TalentDashboard/3-Community.png';
import Job from '../assets/TalentDashboard/4-Job.png';
import Upskilling from '../assets/TalentDashboard/5-Upskilling.png';
import Invite from '../assets/TalentDashboard/6-Invite.png';
import InviteModel from '../components/InviteModel';
// import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import './Home.css';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
    root: {
        minWidth: 275,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
});


const JobPosts = (props) => {
    const [data, setData] = React.useState([]);
    const classes = useStyles();

    React.useEffect(() => {
        fetch(process.env.REACT_APP_IP + '/linkedin')
            .then((response) => response.json())
            .then((data) => {
                setData(data);
                console.log(data)
            })
            .then((response) => {
                console.log(response)
            });
    }, []);


    return (
        <div className="Home">
            <NavBar type='main' />
            <div className="home">

                <center>
                    <br />
                    <br />
                    <div className="col-md-12">
                        <h1 style={{ color: '#153BAB', fontWeight: 'bold' }}>
                            Lyra's Job Board
                    </h1>
                    </div>
                    <br/>
                   <br/>
                    
                    {Array.from({length: 19}, (_, index) => index + 1).map((number)=> 
                    <div className="col-md-9">
                        <Card className={classes.root}>
                            <CardContent>
                                <Typography variant="h5" component="h2">
                                {data && data.companies && data.companies[number]}
                         </Typography>
                                <Typography className={classes.pos} color="textSecondary">
                                {data && data.titles && data.titles[number]}
                        </Typography>

                            </CardContent>
                            <CardActions>
                                <a href= {data && data.links && data.links[number]}>
                                <Button size="small">See More</Button></a>
                            </CardActions>
                        </Card><br/><br/>
                    </div>)}




                </center>

                <div>
                    < Footer />
                </div>
            </div>
        </div>
    );
}

export default JobPosts;
